import React, { useEffect, useState } from "react";
import "./style.scss";
import {
  useGetAccountDataQuery,
  useUpdateAccountDetailsMutation,
} from "../../../services/myAccountAPI";
import Loader from "../fullPageLoader"
import { useGetColorThemeQuery } from "../../../services/commonAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

function Accountdetails() {

  const [formData, setFormData] = useState({});
  const [responseMessage, setResponseMessage] = useState(null);
  const [responseError, setResponseError] = useState(null);
  const {
    data: colorthemeData,
  } = useGetColorThemeQuery();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  // Fetch Billing Data
  const { data, error, isLoading } = useGetAccountDataQuery();
  const [updateBillingAddress, { isLoading: isUpdating }] =
    useUpdateAccountDetailsMutation();

  // Find the billing address for the user
  const accountDetails = data;

  // Set initial form data when billingAddress is available
  useEffect(() => {
    if (accountDetails) {
      setFormData({
        ...accountDetails,
        display_name: accountDetails.name || "", // Map `name` to `display_name`
      });
    }
  }, [accountDetails]);



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setResponseMessage(null);
    setResponseError(null);

    if (!accountDetails?.id) {
      setResponseError("No user datas found for this user.");
      return;
    }

    try {
      const response = await updateBillingAddress({
        body: {
          user_id: accountDetails.id, // Ensure user_id is included in the payload
          ...formData, // Include all other form fields
        },
      }).unwrap();

      if (response?.success) {
        setResponseMessage("Account Details updated successfully!");
      } else {
        setResponseError(response.message || "Failed to edit account details.");
      }
    } catch (err) {
      console.error("Failed to update account details:", err);

      if (err?.data?.message) {
        setResponseError(err.data.message);
      } else {
        setResponseError("Something went wrong while saving the account details.");
      }
    }
  };

  if (isLoading) return <Loader />;
  if (error) return <p>Failed to load page content</p>;

  return (
    <div className="account-details-tab">
      <h2 className="mb-4">Account Details</h2>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6 col-sm-12 col-lg-6">
            <div className="mb-20">
              <label>First Name *</label> <br />
              <input
                type="text"
                name="first_name"
                value={formData.first_name || ""}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="col-md-6 col-sm-12 col-lg-6">
            <div className="mb-20">
              <label>Last Name *</label> <br />
              <input
                type="text"
                name="last_name"
                value={formData.last_name || ""}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="col-md-12 col-sm-12 col-lg-12">
            <div>
              <label>display Name *</label> <br />
              <input
                type="text"
                name="display_name"
                value={formData.display_name || ""}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <p className="mb-20">
            <i>
              This will be how your name will be displayed in the account
              section and in reviews
            </i>
          </p>
          <div className="col-md-12 col-sm-12 col-lg-12">
            <div>
              <label> Email Address *</label> <br />
              <input
                type="email"
                name="email"
                value={formData.email || ""}
                onChange={handleInputChange}
              />
            </div>
          </div>
        </div>

        <div className="password-change">
          <h5>Password Change</h5>
          <div className="col-md-12 col-sm-12 col-lg-12">
            <div className="mb-20">
              <label>Current password (leave blank to leave unchanged)</label>{" "}
              <br />
              <input
                type="password"
                name="current_password"
                value={formData.current_password || ""}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="col-md-12 col-sm-12 col-lg-12">
            <div className="mb-20 position-relative">
              <label>New password (leave blank to leave unchanged)</label>{" "}
              <br />
              <input
                type={showPassword ? "text" : "password"}
                name="new_password"
                value={formData.new_password || ""}
                onChange={handleInputChange}
              />

              <button
                type="button"
                className="absolute show-hide-pasw-btn-accnt-details"
                onClick={() => setShowPassword(!showPassword)}
              >
                <FontAwesomeIcon
                  icon={showPassword ? faEye : faEyeSlash}
                />
              </button>

            </div>
          </div>
          <div className="col-md-12 col-sm-12 col-lg-12">
            <div className="mb-20 position-relative">
              <label>Confirm new password</label> <br />
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="new_password_confirmation"
                value={formData.new_password_confirmation || ""}
                onChange={handleInputChange}
              />

              <button
                type="button"
                className="absolute show-hide-pasw-btn-accnt-details"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                <FontAwesomeIcon
                  icon={showConfirmPassword ? faEye : faEyeSlash}
                />
              </button>
            </div>
          </div>
          <div className="col-md-12 col-sm-12 col-lg-12">
            <button
              type="submit"
              className="primary-button"
              disabled={isUpdating}
              style={{ backgroundColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50" }}
            >
              {isUpdating ? "Saving..." : "Save Changes"}
            </button>
          </div>
          {responseMessage && (
            <p className="success-message">{responseMessage}</p>
          )}
          {responseError && <p className="error-message">{responseError}</p>}
        </div>
      </form>
    </div>
  );
}

export default Accountdetails;
